import React, { useEffect, useState } from "react"
import ConfettiTNT from "../insightsV2/common/confetti"
import { Box, Dialog } from "@mui/material"

const LastCelebration = () => {

    return (
        <div>
            <ConfettiTNT autoStop={false} />
        </div>
    )
}

export default LastCelebration

export const ImageContent = () => {
    const [imageVisible, setImageVisible] = useState(true)
    useEffect(() => {
        setTimeout(() => {
            setImageVisible(false)
        }, 6000)
    }, [])
    return imageVisible && <Box
        position={"fixed"}
        left="50%"
        bottom={-5}
        sx={{
            transform: "translateX(-50%)",
            zIndex: 10000
        }}
    >
        <img src="/bearhurray.png" alt="tutorialcurebear" style={{ zIndex: 10000 }} />
    </Box>
}